import { Analytics } from '@plaudit/analytics';

const analytics = Analytics.getInstance();

const zipCodeSelector = () => {
	const selectorForm = document.getElementById('zipCodeSelector__form') as HTMLFormElement;
	if (!selectorForm) {
		return;
	}

	// NOTE: This poses significant accessibility problems
	selectorForm.addEventListener('change', (event: Event) => {
		const selectEl = event.target as HTMLSelectElement;
		// Don't trigger on select of placeholder value
		if (!selectEl.value) {
			return;
		}

		analytics.trackEvent('Zip Code Selection', 'Select', selectEl.value);
		selectorForm.submit();
	});
};

export default zipCodeSelector;